module.exports = __webpack_public_path__ + "static/media/logo.fa8e7094.png";